/* テキスト */
import React, { memo, useState } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';
import { convert_types, mask_string } from '../Const';
import { convertData } from '../Convert';

interface Props {
  id: string;
  fm_id?: number;
  label: string;
  type?: string; // デフォルトはテキスト
  need?: boolean;
  value: string;
  placeholder: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  name?: string;
  suffix?: string;
  help_msg?: string;
  disabled: boolean;
  maxlength?: number;
  handleBlur?: VoidFunction;
  handleFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  add_comma?: boolean;
  input_assistance?: string;
}

const Text: React.FC<Props> = ({
  id,
  fm_id,
  label,
  type,
  need,
  value,
  placeholder,
  handleChange,
  message,
  name,
  suffix,
  help_msg,
  disabled,
  maxlength,
  handleBlur,
  handleFocus,
  add_comma,
  input_assistance,
}) => {
  const [is_init, setIsInit] = useState(true);

  const returnTextFormJsx = () => {
    /**
     * フォーカスイベント
     * @param event イベントオブジェクト
     */
    const handleFocusInput = (event: React.FocusEvent<HTMLInputElement>) => {
      // 1回目のフォーカスで初期表示フラグを倒す
      if (is_init) {
        setIsInit(false);
      }
      // props.handleFocusがundefinedでなければメソッドを実行する
      if (typeof handleFocus !== 'undefined') {
        handleFocus(event);
      }
    };

    /**
     * 値をセットする
     * @returns value 値（初期表示時はコンバート後の文字列）
     */
    const setValue = () => {
      // input_assistanceがセットされていて、初期表示の時はデータコンバートを行う
      if (typeof input_assistance !== 'undefined' && is_init) {
        return convertData(input_assistance, value);
      }
      return value;
    };

    return suffix ? (
      <>
        <Row>
          <Col>
            <FormControl
              id={id}
              data-fm_id={fm_id}
              type={type}
              placeholder={placeholder}
              value={setValue()}
              onChange={handleChange}
              name={name}
              disabled={disabled}
              onBlur={handleBlur}
              onFocus={handleFocusInput}
              maxLength={maxlength}
            />
          </Col>
          <Col md={2} lg={2} xl={2}>
            {suffix}
          </Col>
        </Row>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    ) : (
      <>
        <FormControl
          id={id}
          data-fm_id={fm_id}
          type={type}
          value={setValue()}
          onChange={handleChange}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          onBlur={handleBlur}
          onFocus={handleFocusInput}
          maxLength={maxlength}
        />
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };
  const returnLabelJsx = () => {
    // valueをセット
    // NOTE input_assistanceにaddCommaが指定されている場合、カンマ区切りを実行する。
    const label_value = add_comma ? convertData(convert_types.add_comma, value) : value;
    // suffixをセット
    const label_suffix =
      !!value?.trim() && suffix !== null && typeof suffix !== 'undefined' ? suffix : '';

    // マスク文字列
    let masked_value = ''; // 初期化
    if (type?.toLowerCase() === 'password' && value !== null && typeof value !== 'undefined') {
      for (let i = 0; i < value.length; i++) {
        masked_value += mask_string;
      }
    }

    return type?.toLowerCase() === 'password' ? (
      <Row>
        <Col>
          <Paragraph label={`${masked_value}${label_suffix}`} />
        </Col>
      </Row>
    ) : (
      <Row>
        <Col>
          <Paragraph label={`${label_value ?? ''}${label_suffix}`} />
        </Col>
      </Row>
    );
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={disabled ? returnLabelJsx() : returnTextFormJsx()}
    />
  );
};

export default memo(Text);
